import { useState } from "react";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";

import { twMerge } from "tailwind-merge";
import { useIsomorphicLayoutEffect } from "usehooks-ts";

import { faSortUp } from "@fortawesome/free-solid-svg-icons/faSortUp";

import FontAwesomeIcon from "components/FontAwesomeIcon";

export default function GoToTopButton({
  className,
  targetRef,
}: {
  className?: string;
  targetRef?: React.RefObject<HTMLElement>;
}) {
  const [right, setRight] = useState(0);

  function updateRight() {
    if (window.innerWidth > 1328) {
      setRight((window.innerWidth - 1328) / 2 + 335);
    } else if (window.innerWidth > 1024) {
      setRight(335);
    } else {
      setRight(20);
    }
  }

  useIsomorphicLayoutEffect(() => {
    updateRight();
    window.addEventListener("resize", updateRight);
    return () => window.removeEventListener("resize", updateRight);
  }, []);

  return (
    <OverlayTrigger placement="left" overlay={<Tooltip>To Top</Tooltip>}>
      <button
        onClick={() => {
          if (targetRef) {
            // TODO: find preper way to handle nested scrollable div
            targetRef?.current?.scrollTo(0, 0);
            targetRef?.current?.parentElement?.scrollTo(0, 0);
            targetRef?.current?.parentElement?.parentElement?.scrollTo(0, 0);
            targetRef?.current?.parentElement?.parentElement?.parentElement?.scrollTo(
              0,
              0
            );
          } else {
            window.scrollTo(0, 0);
          }
        }}
        style={{ right }}
        className={twMerge(
          "flex-col text-[#999]",
          "border-none bg-transparent fixed bottom-[10px]",
          "hidden md:flex items-center z-[999]",
          className
        )}
      >
        <FontAwesomeIcon icon={faSortUp} className="mb-[-7px]" />
        <span className="text-[12px]">Top</span>
      </button>
    </OverlayTrigger>
  );
}
